import type { GroupSP, UserSP } from '@/features/sharing-profile/types/sharing-profile.interface';

/**
 * A user available in the current space, as returned by the space users API.
 * Superset of `UserSP` shape plus a status flag used to filter out pending invites.
 */
export interface AvailableSpaceUser extends UserSP {
  status?: string;
}

export interface SharingUserManagementState {
  /** Users assigned to the sharing profile being created/edited. */
  users: UserSP[];
  /** Groups assigned to the sharing profile being created/edited. */
  groups: GroupSP[];
  /** Users available in the current space to pick from when assigning. */
  availableUsers: AvailableSpaceUser[];
  /** Loading flag for fetching/updating available space users. */
  isUserManagementLoading: boolean;
}

export const initialUserManagementState: SharingUserManagementState = {
  users: [],
  groups: [],
  availableUsers: [],
  isUserManagementLoading: false,
};
